import React from 'react';

export default function ReminderPopup({ reminder, medicine, onConfirm, onSnooze, snoozeCount }) {
  if (!reminder) return null;
  const canSnooze = snoozeCount < 3;

  return (
    <div className="popup-overlay">
      <div className="popup">
        <div className="popup-title">⏰ 该吃药了</div>
        <div className="popup-body">
          <p style={{ fontSize: 'var(--font-size-large)', fontWeight: 700, marginBottom: 8 }}>
            {medicine?.name || '药品'}
          </p>
          <p>服用 {medicine?.dosage || ''} {medicine?.unit || '片'}</p>
          {medicine?.notes && (
            <p style={{ marginTop: 8, color: 'var(--warning-color)', fontSize: 'var(--font-size-small)' }}>
              注意：{medicine.notes}
            </p>
          )}
        </div>
        {/*
          按钮排布说明（改之前请先读 global.css 里 .popup-actions 的注释）：
          这里曾经是三个按钮挤在一行（flex:1 + 内联 white-space:nowrap）。
          按钮的 min-width 默认是 auto、文字又不许换行，
          于是「文字宽度 + 左右各 24px 内边距」三份加起来必然超过弹窗内容宽度，
          窄屏和大字号下按钮直接溢出到弹窗外面。
          现在交给 .popup-actions 做可换行的竖排优先布局，不要在这里写死宽度/换行。
        */}
        <div className="popup-actions">
          <button className="btn-primary popup-btn-main" onClick={() => onConfirm('taken')}>
            ✅ 已服用
          </button>
          {canSnooze && (
            <button className="btn-secondary popup-btn-sub" onClick={() => onSnooze()}>
              ⏰ 稍后提醒
            </button>
          )}
          <button className="btn-secondary popup-btn-sub" onClick={() => onConfirm('skip')}>
            ⏭️ 跳过
          </button>
        </div>
        {!canSnooze && (
          <p style={{ marginTop: 12, color: 'var(--text-light)', fontSize: 'var(--font-size-small)' }}>
            稍后提醒已达上限，请确认服药
          </p>
        )}
      </div>
    </div>
  );
}